import AfterConfirmText from './AfterConfirmText';

export default AfterConfirmText;
